import React from 'react';
import { groupBy } from 'lodash';
import { useViewport } from 'components/templates/viewportProvider';
import { CallToAction } from 'components/atoms/callToAction';
import rupeeIcon from 'assets/images/rupee-icon-pink.png';
//eslint-disable-next-line
import styles from "./styles.scss";

const RentAdvertisement = props => {
  const { isMobile } = useViewport();
  const {
    adData: {
      price,
      bed,
      bath,
      duration,
      quote,
      deposit,
      location,
      rental_image,
      rental_mobile_image,
    },
    projectList,
  } = props.data;
  let className = 'rent-ad';
  let image = rental_image;
  if (isMobile) {
    className = 'rent-ad-mobile';
    image = rental_mobile_image;
  }

  const rentals = groupBy(projectList, 'name');
  let locationCount = Object.keys(rentals).length;
  let houseCount = projectList.length;

  const renderCount = () => {
    return (
      <h3>
        {`${houseCount}${' '}${
          houseCount === 1 ? 'Unit' : 'Units'
        } available for rent, across
        ${locationCount}${' '}${
          locationCount === 1 ? 'location' : 'locations'
        }.`}
      </h3>
    );
  };

  return (
    <div className={className} id={'rent-home'}>
      <div className={'inner-section'}>
        <div className={'text-section'}>
          <h1>Let Us Help Rent Your Home</h1>
          {renderCount()}
          <a href={'#projects'}>
            <CallToAction
              text={'LEARN MORE'}
              onClick={() => {}}
              mode={'transparent'}
              className={'learn-more'}
            />
          </a>
        </div>
        <div className={'image-section'}>
          <div className={'image-container'}>
            <img src={image} alt={'image-failed'} />
          </div>
          <div className={'image-description'}>
            <h2 className={'quote'}>{quote}</h2>
            <div className={'short-description'}>
              <div className={'icon-container'}>
                <img className={'rupee-icon'} src={rupeeIcon} alt={''} />
                <h4 className={'price-per-month'}>{price}</h4>
              </div>
              <h4 className={'duration'}>{duration}</h4>
              <div className={'icon-container'}>
                <img className={'rupee-icon'} src={rupeeIcon} alt={''} />
                <h4 className={'deposit'}>{deposit}</h4>
              </div>
            </div>
            <div className={'short-text'}>
              <h4
                className={'specs'}
              >{`${bed}${' '}bed${' '}/${' '}${bath}${' '}bath`}</h4>
              <h4 className={'location'}>{location}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RentAdvertisement;
